export default [
    {
      path: '/plans/containerDump/list',
      name: 'plans.containerDump.list',
      component: () => import('@/views/modules/plans/containerDump-plan/plan-list/PlansList'),
      meta: {
        module: 'plans.containerDump',
        pageTitle: 'RFID Reader Plans',
        breadcrumb: [
        // { text: 'List containerDump Plans', active: true, },
          //{ text: 'Create Plan', to: {name: 'plans.rain.create'} }
        ],
      }
    },
  
  
    {
      path: '/plans/containerDump/create',
      name: 'plans.containerDump.create',
      component: () => import('@/views/modules/plans/containerDump-plan/CreateContainerDumpPlan.vue'),
      meta: {
        module: 'plans.containerDump',
        pageTitle: 'Create Rfid Reader Plan',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.containerDump.list'} },
          { text: 'Create Rfid Reader Plan' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/containerDump/:id/edit',
      name: 'plans.containerDump.edit',
      component: () => import('@/views/modules/plans/containerDump-plan/EditContainerDumpPlan.vue'),
      meta: {
        module: 'plans.containerDump',
        pageTitle: 'Edit Rfid Reader Plan',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.containerDump.list'} },
          { text: 'Edit Plan' , active: false},
         
        ],
      }
    },
  ]
  